import { reactive, toRefs, onMounted, computed } from "vue";
import { useSessionStore } from "@/store/session-store";
import { UseLoginFormResult } from "./use-login-form-result.interface";
import { formatEmail } from "@/utils/email.functions";
import { useRoute } from "vue-router";
import { clearLocalStorageAuthItems } from "../../../../types/auth-local-storage/auth-local-storage.functions";

export function useLoginForm(): UseLoginFormResult {
  const route = useRoute();
  const store = useSessionStore();
  const isLoading = computed(() => store.getIsLoading);
  const { email, password } = toRefs(
    reactive({
      email: "",
      password: "",
    })
  );
  const signIntoApp = async () => {
    clearLocalStorageAuthItems();
    store.createSession({
      email: formatEmail(email.value),
      password: password.value,
    });
  };

  onMounted(() => {
    email.value = route?.query?.email as string;
  });

  return {
    email,
    password,
    signIntoApp,
    isLoading,
  };
}
